export const FAVORITES_FETCH_REQUESTED = 'user/FAVORITES_FETCH_REQUESTED';
export const FAVORITES_FETCH_SUCCEEDED = 'user/FAVORITES_FETCH_SUCCEEDED';
export const FAVORITES_FETCH_FAILED = 'user/FAVORITES_FETCH_FAILED';
export const REMOVE_FAVORITE_OR_SAVED_REQUESTED =
  'user/REMOVE_FAVORITE_OR_SAVED_REQUESTED';
export const REMOVE_FAVORITE_OR_SAVED_SUCCEEDED =
  'user/REMOVE_FAVORITE_OR_SAVED_SUCCEEDED';
export const REMOVE_FAVORITE_OR_SAVED_FAILED =
  'user/REMOVE_FAVORITE_OR_SAVED_FAILED';
